import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  show({ params: { id } }: { params: { id: string } }) {
    const event = new CustomEvent("show-dialog", {
      detail: { dialogId: id },
      bubbles: true,
    });
    this.element.dispatchEvent(event);
  }
}
